/**
 * Main controller for Product and ATC functions
 * /assets/product-atc.js
 *
 * $.updateATC (Check all atc-item in page and update atc button accordingly)
 */

whenAvailable('$', function() {

$(function () {
    const is_2022_series_product_page = Boolean(document.querySelector('[data-page-handle=titan-evo-2022-series]'));
    const is_skins_product_page = Boolean(document.querySelector('[data-page-handle=skins]'));
    const is_evo_lite_product_page = Boolean(document.querySelector('[data-page-handle=titan-evo-lite]'));
    const is_product_page_with_you_save_liner = is_2022_series_product_page || is_skins_product_page || is_evo_lite_product_page
    const you_save_liner_exist = typeof has_you_save_liner !== 'undefined';

    $.formatPreorderDate = function(date, length, type) {
        if (typeof date == 'string') {
            date = new Date(date);
        }

        var message = localization.pre_order_message;
        if (length == 'short') {
            message = localization.pre_order + ': <!-- date -->';
        }

        // Type 'full' will show the dd mmm yyyy format
        if (type === 'full') {
            const mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            let month = mon[date.getMonth()];

            return message.replace('<!-- date -->', date.getDate() + ' ' +  month + ' ' + date.getFullYear());
        } else {
            if (shop_locale == 'ko') {
                return message.replace('<!-- date -->', date.getMonth()+1 + '월 ' + date.getDate() + '일');
            } else {
                var day = date.getDate() + 'th';
                if (day !== '11th' && day !== '12th' && day !== '13th') {
                    day = day.replace('1th', '1st').replace('2th', '2nd').replace('3th', '3rd');
                }

                var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                month = month[date.getMonth()];

                return message.replace('<!-- date -->', day + ' ' + month);
            }
        }
    }



    $.updateUrlParam = function(e) {
        // Triggered by human, therefore update URL parameter
        if ( typeof e != 'undefined' ) {
            if ( e.originalEvent ) {
                if ( e.originalEvent.isTrusted == true && ($('[data-atc-id]').length > 1 || $('.atc-item-variant').length > 0)) {
                } else { return; }
            } else {
                return;
            }
        }

        var paramSKU = '';
        $('[data-atc-id]').each(function(i, v) {
            sku = $(v).attr('data-sku');
            quantity = $(v).attr('data-quantity');
            if (!sku.match(/^(-|MPB1-(15|17))$/) && !sku.match(/^(-|MPB1B-(15|17))$/) && quantity != '0') {
                paramSKU = paramSKU + (i != 0 && paramSKU != '' ? ',' : '') + $(v).attr('data-sku') + (quantity != '1' ? '=' + quantity : '');
            }
        });

        window.history.replaceState(null, null, "?sku=" + paramSKU);
    }

    if ( $('#preorder_info').length > 0 ) {
        const updatePreorderInfo = function(target) {
            if (target == undefined) {
                target = $('button.atc-item-variant.active[data-type="Chair"]');
            }

            $('.preorder-control').hide();

            var skuCurrent = $(target).attr('data-sku'),
                skuPrefix = 'S22';

            if ( skuCurrent.indexOf('R22') !== -1 ) { skuPrefix = 'R22'; }
            else if ( skuCurrent.indexOf('XL22') !== -1 ) { skuPrefix = 'XL22'; }

            if ( $('.preorder-control[data-sku="' + skuCurrent + '"]').length > 0 && $(target).attr('data-status').match(/^(pre-order|out-of-stock)$/) ) {
                $('.preorder-control[data-sku="' + skuCurrent + '"]').show();
            } else if ( !$('#preorder_info').hasClass('init-' + skuPrefix) ) {
                $('#preorder_info').addClass('init-' + skuPrefix)
                get_preorder_info(skuPrefix);
            }
        }

        function build_preorder_bar(round, estimated_date, percentage) {
            if (null === estimated_date || '' === estimated_date || undefined === estimated_date) {
                return '';
            } else {
                percentage = 100 - parseInt(percentage);
                var percent_word = percentage + '%',
                    cls = 'bg-warning progress-bar-striped progress-bar-animated',
                    txt_cls = '', div_style = '';
                if (0 == percentage) {
                    percentage = 100;
                    percent_word = localization.sold_out;
                    txt_cls = 'text-gray500';
                    cls = 'bg-transparent text-gray500';
                } else if (100 === percentage) {
                    percentage = 100;
                    percent_word = '0%';
                    cls = 'bg-light text-dark';
                    txt_cls = 'text-black-50';
                    div_style = 'style="border-left: 1px solid #f00;"';
                }

                var formattedDate = $.formatPreorderDate(estimated_date);
                var html = '<div class="row mt-3 mb-1">' +
                                '<div class="col-auto strong ' + txt_cls + '">' + localization.pre_order_wave.replace('<!-- wave_no -->', round) + '</div>'+
                                '<div class="col ps-0"' + div_style + '>'+
                                    '<div class="progress"><div class="progress-bar strong ' + cls + '" style="width:' + percentage + '%" role="progressbar" aria-valuenow="' + percentage + '" aria-valuemin="0" aria-valuemax="100">' + percent_word + '</div></div>' +
                                    '<div class="' + txt_cls + '"><b class="' + (percentage != 100 ? 'text-warning' : '') + '">' + percent_word + (percentage != 100 ? ' ' + localization.stocks_left : '') + '</b> - ' + formattedDate +
                            '</div></div></div>';
                return html;
            }
        }

        function get_preorder_info(skuPrefix) {
            var product_handle = skuPrefix.replace('S22', 'titan-evo-sml-series').replace('R22', 'titan-evo-reg-series').replace('XL22', 'titan-evo-xl-series');

            $.get('https://beans.secretlab.co/index.php/api/2019-08/' + shop_locale + '/product_page/' + store_code + '/' + product_handle, function (data) {
                // STOCK INFO
                $.each(data.stock_info.preorder, function (i, v) {
                    var wave_html='';
                    var count = 1;
                    while (v['round_' + (count + 1) + '_raw_date'] !== undefined) {
                        count++;
                    }

                    // ONLY SHOW LATEST 3 BAR
                    var rename_wave_no = 1;
                    for (var index = (count > 3 ? count - 2 : 1); index <= count; index++) {
                        wave_html += build_preorder_bar(rename_wave_no, v['round_' + index + '_raw_date'] , v['round_'+ index +"_percent"] );
                        rename_wave_no++;
                    }

                    if (wave_html) {
                        $('#preorder_info').append('<div class="preorder-control" data-sku="' + v.variant_sku + '" style="display:none">' + wave_html + '</div>');
                    }
                });

                // IF PRODUCT IS INITIALIZED, AND PRE-ORDER INFO EXIST, SHOW IT
                updatePreorderInfo();
            }, 'json');
        }
    }



    $.updateInstalmentPrice = function(target) {
        if ( $('.financing [data-instalment-min]').length > 0 ) {
            total_price = parseInt($('[data-total-price]').attr('data-total-price'));
            min = parseInt($('[data-instalment-min]').attr('data-instalment-min'));

            if (total_price < min) {
                $('.financing').stop().slideUp();
            } else {
                if ( $('.financing .instalment-amt').length > 0 ) {
                    $('.financing .instalment-amt').each(function(i, v) {
                        split = $(v).attr('data-instalment-split');
                        $(v).html( Math.ceil(total_price / split) );
                    });
                }

                if ( store_code == 'US' ) {
                    /*
                    $('.affirm-as-low-as').attr('data-amount', total_price*100);
                    affirm.ui.ready(function(){ affirm.ui.refresh(); });
                    try {
                        preorderDate_r = $(target).attr('preorder-date-r');
                        if ( preorderDate_r != '' ) {
                            currentDate = new Date();
                            preorderDate = new Date(preorderDate_r);
                            diffTime = preorderDate.getTime() - currentDate.getTime();
                            diffDay = Math.ceil(diffTime / (1000 * 3600 * 24));

                            if ( diffDay >= 30 ) {
                                $('.affirm-as-low-as').hide();
                            } else {
                                $('.affirm-as-low-as').show();
                            }
                        } else {
                            $('.affirm-as-low-as').show();
                        }
                    } catch(e) { $('.affirm-as-low-as').hide(); }*/

                    $('.paylater-affirm').attr('data-amount', total_price*100);
                    let instalment_split = 12;
                    if (total_price >= 700) {
                        instalment_split = 6;
                    }
                    $('.paylater-affirm .dynamic-instalment-split').text(instalment_split);
                    $('.paylater-affirm .dynamic-instalment-amount').text(Math.ceil(total_price/instalment_split));
                }

                // if ( store_code == 'EU' || store_code == 'UK' ) {
                //     $('.paylater-splitit').attr('data-splitit-amount', total_price);
                //     try { splitit.ui.refresh(); } catch(e) {}
                // }

                $('.financing').stop().slideDown(function() {
                    $(this).attr('style', '');
                });
            }
        }
    }


    // FINANCING MODAL
    $('body').on('click', '[data-financing-modal-react]', function(e) {
        e.preventDefault();

        const updateInstalmentPrice = () => {
            const total_price = $('[data-react-total]').attr('data-react-total') || 0;
            if ( $('.instalment-amt').length > 0 ) {
                $('.instalment-amt').each(function(i, v) {
                    const split = $(v).attr('data-instalment-split');
                    $(v).html( Math.ceil(total_price / split) );
                });
            }
        }

        const loader = `
          <div id="financingModalOverlay" class="modal-overlay absolute d-flex justify-content-center align-items-center active financing">
              <div class="collection-sidebar-spinner">
                  <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                  </div>
              </div>
          </div>
        `;

        if (!$('#financingModal').length) {
            const html = `<div class="modal fade ajax-modal" id="financingModal" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div class="modal-content overflow-hidden">
                                    ${loader}
                                </div>
                            </div>
                        </div>`;
            $('main').append(html);
        } else {
          $('#financingModal .modal-content').html(loader);
        }

        $('#financingModal').modal('show');

        const financingProvider = $(this).attr('data-financing') ? `-${$(this).attr('data-financing')}` : '';

        $.ajax({
            dataType: "html",
            url: locale_root + `/?view=financing-modal${financingProvider}`,
        }).then(function(data) {
            var content = $(data).filter('#ajaxFinancingModal');
            $('#financingModalOverlay').removeClass('active');
            $('#financingModal .modal-content').html(content.html());

            updateInstalmentPrice()
        });
    });

    $('body').on('click', '[data-sg-modal-grab-react]', function(e) {
        e.preventDefault();

        const content = `<div id="ajaxFinancingModal">
                            <div class="modal-header bg-mild p-4 border-0">
                                <h5 class="modal-title text-secondary">Grab</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body p-4">
                                <h6 class="fluid-type light mb-4">Get additional <b>$10</b> off when you checkout with PayLater by Grab from 3 May to 10 May.</h6>  
                                                              
                                <p><b>*Here’s how it works:</b></p>
                                <ol>
                                <li>Pick your preferred product and proceed to checkout</li>
                                <li>Select Grab as your payment method at the checkout page.</li>
                                <li>Select ‘Pay Next Month’ or ‘Pay in 4 instalments’ to checkout via PayLater by Grab.</li>
                                <li>Click ‘Add offers’ and key in ‘PAYLATERMAY’ to receive the discount.</li>

                                </ol>
                                 <p><b>Terms and Conditions:</b></p>
                                 <ul>
                                    <li>*Valid on a minimum purchase of $100.</li>
                                    <li>Promotion is non-refundable in the event of a refund. </li>
                                    <li>Promotion is not valid in conjunction with any other discounts, offers, privileges, promotions and vouchers.</li>
                                    <li>Users are responsible to check that the voucher is successfully applied before making payment; the voucher cannot be retrospectively applied once payment is made.</li>
                                    <li>Offer is valid from 3 May 2025 (12:00am) - 10 May 2025 (11:59pm). </li>
                                </ul>
                            </div>
                        </div>`;

        const html = `<div class="modal fade ajax-modal" id="financingModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content overflow-hidden">
                    ${content}
                </div>
            </div>
        </div>`;
        
        if (!$('#financingModal').length) {
            $('main').append(html);
        } else {
            $('#financingModal .modal-content').html(content);
        }

        $('#financingModal').modal('show');
    });


    $('body').on('click', '[data-sg-modal-shopback-react]', function(e) {
        e.preventDefault();
                const content = `<div id="ajaxFinancingModal">
                                        <div class="modal-header bg-mild p-4 border-0">
                                            <h5 class="modal-title text-secondary">ShopBack</h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body p-4">
                                            <h6 class="fluid-type light mb-4">Get additional <b>$11*</b> off when checking out with Shopback from 29 November to 2 December.</h6>                                            
                                            <p><b>*Terms and Conditions:</b></p>
                                            <ul>
                                                <li>All ShopBack customers can enjoy $11 off with a minimum spend of $150.</li>
                                                <li>To enjoy the discount, claim the voucher on the ShopBack app under 'Payments' or 'Pay Promos page'. The voucher can then be applied at check out.</li>
                                                <li>Promotion is valid from 29 November to 2 December.</li>
                                                <li>Limited to 1 redemption per user.</li>
                                        </div>
                                    </div>`
            const html = `<div class="modal fade ajax-modal" id="financingModal" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div class="modal-content overflow-hidden">
                                    ${content}
                                </div>
                            </div>
                        </div>`;

        if (!$('#financingModal').length) {
            $('main').append(html);
        } else {
            $('#financingModal .modal-content').html(content);
        }

        $('#financingModal').modal('show');
    });
});

});

